/** @jsxImportSource @emotion/react */
import { useLanguage } from "LanguageContext";
import { css, useTheme } from "@emotion/react";

function PageNotFound() {
  const { t } = useLanguage();
  const theme = useTheme();

  return (
    <div>
        <h2> {t("page_not_found_txt")} ..! </h2>
    </div>
  )
}
export default PageNotFound;